module.exports = __webpack_public_path__ + "static/lolipop-1-032036ef056cf1863206acc32a54ff19.jpg";